module.exports = __webpack_public_path__ + "static/media/logo.6808bf90.svg";